import { AbstractModel } from ".";

export default class UserReaction extends AbstractModel {
  value!: string;
  userId!: string;
  firstName!: string;
  lastName!: string;
}
